<template>
    <div >
        <transition>

            <div class="alert alert-success text-center" role="alert" v-show="user.show_tutorial">
                <button
                        v-if="!confirmationShown"
                        v-on:click="showConfirmation"
                        type="button"
                        class="close">
                    ×
                </button>

                <nl2br tag="span" :text="'Before you start, watch carefully Presentation videos of the new Pelican console.'|trans"/>
                <br>

                <router-link to="/tutorials" class="btn btn-default">
                    <i class="icon fa fa-graduation-cap"></i>&nbsp;
                    <span class="title">{{'Pelican Academy'|trans}}</span>
                </router-link>
                <br>

                <div
                        v-if="confirmationShown"
                        class="confirmation">
                    <input
                            v-on:click="confirm"
                            type="checkbox">
                    {{ 'I confirm that I have see the tutorials.' | trans }}
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    export default {
        props : {
            user :Object
        },
        data() {
            return {
                confirmationShown: false,
            }
        },
        methods: {
            showConfirmation() {
                this.confirmationShown = true;
            },
            confirm() {
                this.confirmationShown = false;
                this.dontShowMessageTutorial();
            },
            async dontShowMessageTutorial(){
                const response = await this.$api.worker.dontShowMessageTutorial(this.user.user_id);
                if(response.success === true){
                    this.user.show_tutorial = false;
                }
            },
        },
        async created() {

        }
    }
</script>

<style scoped>
    .close {
        margin-left: 10px;
    }
    input[type=checkbox] {
        -ms-transform: scale(2); /* IE */
        -moz-transform: scale(2); /* FF */
        -webkit-transform: scale(2); /* Safari and Chrome */
        -o-transform: scale(2); /* Opera */
        margin-right: 10px;
    }
    .confirmation {
        margin-top: 10px;
    }
    .v-leave-active {
        transition: all 300ms;
    }
    .v-leave {
        opacity: 1;
        max-height: 200px;
    }
    .v-leave-to {
        opacity: 0;
        max-height: 0;
    }
</style>
